(function (w, d) {
  var GTM_ID = 'GTM-TMBDMTC5';
  var gtmLoaded = false;
  var trackingGrantedPushed = false;
  var lastConsentState = '';

  w.dataLayer = w.dataLayer || [];
  w.gtag = w.gtag || function () {
    w.dataLayer.push(arguments);
  };

  // Consent Mode Default immer zuerst setzen
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });

  function getPrivacyApi() {
    return w.Shopify && w.Shopify.customerPrivacy ? w.Shopify.customerPrivacy : null;
  }

  function getConsentState(cp) {
    return {
      analytics: !!cp.analyticsProcessingAllowed(),
      marketing: !!cp.marketingAllowed()
    };
  }

  function hasRequiredConsent(state) {
    return state.analytics && state.marketing;
  }

  function syncGoogleConsent(state) {
    gtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing ? 'granted' : 'denied',
      ad_personalization: state.marketing ? 'granted' : 'denied'
    });
  }

  function pushConsentState(state) {
    var stateKey = String(state.analytics) + '|' + String(state.marketing);

    if (stateKey === lastConsentState) return;
    lastConsentState = stateKey;

    w.dataLayer.push({
      event: 'shopify_consent_state',
      shopify_analytics_allowed: state.analytics,
      shopify_marketing_allowed: state.marketing
    });
  }

  function loadGTM() {
    if (gtmLoaded) return;
    gtmLoaded = true;

    w.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js'
    });

    var s = d.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;
    d.head.appendChild(s);
  }

  function pushTrackingGranted(state) {
    if (!hasRequiredConsent(state)) return;
    if (trackingGrantedPushed) return;

    trackingGrantedPushed = true;

    w.dataLayer.push({
      event: 'shopify_tracking_granted',
      shopify_analytics_allowed: true,
      shopify_marketing_allowed: true
    });
  }

  function handleConsent() {
    var cp = getPrivacyApi();
    if (!cp) return;

    var state = getConsentState(cp);

    syncGoogleConsent(state);
    pushConsentState(state);

    if (hasRequiredConsent(state)) {
      loadGTM();
      pushTrackingGranted(state);
    }
  }

  function initPrivacyApi() {
    if (!w.Shopify || !w.Shopify.loadFeatures) return;

    w.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;

        handleConsent();
        d.addEventListener('visitorConsentCollected', handleConsent);
      }
    );
  }

  (function boot(retries) {
    if (w.Shopify && w.Shopify.loadFeatures) {
      initPrivacyApi();
      return;
    }

    if (retries > 40) return;

    setTimeout(function () {
      boot(retries + 1);
    }, 50);
  })(0);

})(window, document);